






















module.exports =
  name: 'payment_bar'
  computed:
    access_status: ->
      return 'expired' if @$store.getters.days_till_end < 0
      return 'soon'    if @$store.getters.days_till_end < 10 && !@existing_subscription
      return 'active'
    paid_till: -> @$store.state.user.userdata.paid_till
    existing_subscription: -> @$store.state.user.userdata.stripe_info?.customer_id
    payment_plan: -> @$store.getters.payment_plan
    link: ->
      prefix = if HM.is_mobile then 'mobile_' else ''
      if @payment_plan == 'ru'
        { name: prefix + 'payment_page' }
      else
        { name: prefix + 'subscription_page' }
